import '../styles/NavBar.css';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import NavigationList from './NavigationList';

import imageLogo from '../../images/icons/logo.svg';
import imageMenu from '../../images/icons/hamburger.svg';

function NavBar() {

    const [active, setMode] = useState(false);

    const ToggleMode = () => {

        setMode(!active);

    }

    return (

        <nav className='navbar_c'>

            <div>

                <Link to='/'>

                    <img src={imageLogo} alt='logo navbar' />

                </Link>

            </div>

            <img className='icon_openMenu' src={imageMenu} alt='' onClick={ToggleMode} />

            <div
                className={active ? 'menu_mobile menuOpen animate__animated animate__faster animate__zoomIn' : 'menu_mobile menuClose'}>

                <NavigationList type='nav_item' />

            </div>

        </nav>

    )

}

export default NavBar;